import { withTiming, withSequence, withRepeat } from 'react-native-reanimated';
import { HapticFeedback } from '@bonanza-social/toolkit/utils';

export const shake = () => {
  HapticFeedback.trigger('notificationError');

  return withRepeat(
    withSequence(
      ...[0, 1, -1].map((value) => withTiming(value, { duration: 50 })),
    ),
    3,
    true,
  );
};
